import { postForm } from '@/shared/api/client';
import type { ListParams, ListResponse } from '@/shared/ui/list/types';

/** `GenericListPage.fetchList` for endpoints taking the assembled params as a multipart POST body. */
export const postListFetcher = (endpoint: string) => (params: ListParams) =>
  postForm<ListResponse>(endpoint, params);
